import CatalogTransferWizardHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/CatalogTransferWizardHeader'
import React from 'react'

const ImportCatalogStepHeader = () => (
    <CatalogTransferWizardHeader title="Upload File Containing Verified Works">
        <div className="ct-import-step-header-copy">
            <p>Upload your updated Excel file containing the works you want to include in your transfer request.</p>
            <p>
                <strong>Reminder:</strong>
                <br />
                Make sure to upload the <strong>edited version of the Excel file we sent you</strong>, containing your
                verification/confirmation for each work listed; not the original Excel file we sent you.file.
            </p>
            <div>
                <strong>Tips:</strong>
                <br />
                <ul>
                    <li>Size limit: You can upload up to 10,000 rows per file.</li>
                    <li>File format: Your file must be saved in .xlsx format to upload successfully.</li>
                </ul>
            </div>
        </div>
    </CatalogTransferWizardHeader>
)

export default ImportCatalogStepHeader
